<template>
  <DoughnutChartGenerator :chart-data="data" :chart-options="options" :style="{ width: size, height: size }" />
</template>
<script>
import { Doughnut as DoughnutChartGenerator } from 'vue-chartjs/legacy'

import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'DoughnutChart',
  props: {
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => {},
    },
    direction: {
      type: String,
      default: () => 'row',
    },
  },
  computed: {
    size() {
      return this.direction === 'row' ? '285px' : '300px'
    },
  },
  components: {
    DoughnutChartGenerator,
  },
}
</script>

<style lang="scss">
#doughnut-chart {
  position: relative;
  z-index: 50;
  width: 100%;
  height: 100%;
}
</style>
